import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import './style.scss'
function HomePage() {

    const [version, setVersion] = useState(null);

    useEffect(() => {
        getVersion()
    }, []);

    async function getVersion() {
        try {
            const result = await (await Axios.get(`${process.env.REACT_APP_API_HOST}/version`)).data;
            console.log('result :>> ', result);
            setVersion(result)
        } catch (error) {
            console.log('error :>> ', error);    
        }
    }

    
   return(
       <div className='warp-home-page'>
            <h1>
            Metaverse Service
            </h1>
            <br/>
            <h3>Version {version ? version : "-"}</h3>
            <h4>Version Front {process.env.REACT_APP_VERSION}</h4>
       </div>
   ) 
}

export default HomePage